import React, { useState } from 'react';
import axios from 'axios';
import './ForgotPassword.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleResetRequest = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        'https://wholeness-forward.onrender.com/api/auth/forgot-password',
        { email }
      );
      setMessage({ text: response.data.message, type: 'success' });
    } catch (error) {
      setMessage({ 
        text: error.response?.data?.message || 'Request failed. Please try again.', 
        type: 'error' 
      });
    }
  };

  return (
    <div className="forgot-password-container">
      <form className="forgot-password-card" onSubmit={handleResetRequest}>
        <h1>Forgot Password</h1>
        <p className="forgot-instructions">
          Enter your email below, and we'll send you a password reset link.
        </p>
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="forgot-password-input"
        />
        <button type="submit" className="forgot-password-button button">
          Request Reset
        </button>

        {message.text && (
          <div className={`forgot-message ${message.type}`}>
            {message.text}
          </div>
        )}
      </form>
    </div>
  );
};

export default ForgotPassword;
